import request from "@/utils/request";

// 查询所有课时列表
export const  classLibraryListAll =(query) =>{
    return request({
        url: "/businessservice/classLibrary/listAll",
        method:"get",
        params: query
    })
}

// Excel批量导入课程
export const  classLibraryBatchImport =(data) =>{
    return request({
        url: "/businessservice/classLibrary/batchImport",
        method:"post",
        data: data
    })
}

// 创建课本
export const  classLibraryCreate =(data) =>{
    return request({
        url: "/businessservice/classLibrary/create",
        method:"post",
        data: data
    })
}

// 创建单元或课程
export const  classLibraryCreateUnit =(data) =>{
    return request({
        url: "/businessservice/classLibrary/createUnit",
        method:"post",
        data: data
    })
}
// 删除课本
export const  classLibraryDelete =(query) =>{
    return request({
        url: "/businessservice/classLibrary/delete",
        method:"get",
        params: query
    })
}
// 查询课本详情
export const  classLibraryInfo =(query) =>{
    return request({
        url: "/businessservice/classLibrary/info",
        method:"get",
        params: query
    })
}
// 查询所有课本
export const  classLibraryListAllBook =(query) =>{
    return request({
        url: "/businessservice/classLibrary/listAllBook",
        method:"get",
        params: query
    })
}
// 查询所有课本(包括单元及课)
export const  classLibraryListTree =(query) =>{
    return request({
        url: "/businessservice/classLibrary/listTree",
        method:"get",
        params: query
    })
}

// 查询所有课本(包括单元及课)
export const  classLibraryListTreeNew =(query) =>{
    return request({
        url: "/businessservice/classLibrary/listTreeNew",
        method:"get",
        params: query
    })
}

// 查询所有课本(包括单元及课)
export const  infoClassLibrary =(query) =>{
    return request({
        url: "/businessservice/classLibrary/info",
        method:"get",
        params: query
    })
}

// 更新课时(课本、单元、课程)
export const  classLibraryUpdate =(data) =>{
    return request({
        url: "/businessservice/classLibrary/update",
        method:"post",
        data: data
    })
}
// 上传课本封面
export const  classLibraryUploadCover =(data) =>{
    return request({
        url: "/businessservice/classLibrary/uploadCover",
        method:"post",
        ContentType:'multipart/form-data',
        data: data
    })
}

// 添加版本分类
export const  classLibraryAddClassify =(query) =>{
    return request({
        url: "/businessservice/classLibrary/addClassify",
        method:"get",
        params: query
    })
}

// 查询列表
export const  listClassLibrary =(data) =>{
    return request({
        url: "/businessservice/classLibrary/listBook",
        method:"post",
        data: data
    })
}

// 详情
export const  infoBook =(query) =>{
    return request({
        url: "/businessservice/classLibrary/infoNew",
        method:"get",
        params: query
    })
}

/*===================课程结构==================*/
// 创建课程结构
export const  createClassLibraryItem =(data) =>{
    return request({
        url: "/businessservice/classLibraryItem/create",
        method:"post",
        data: data
    })
}

// 更新课程结构
export const  updateClassLibraryItem =(data) =>{
    return request({
        url: "/businessservice/classLibraryItem/update",
        method:"post",
        data: data
    })
}

// 删除课程结构
export const  deleteClassLibraryItem =(query) =>{
    return request({
        url: "/businessservice/classLibraryItem/delete",
        method:"get",
        params: query
    })
}

// 查询课程结构树形列表
export const  treeListClassLibraryItem =(query) =>{
    return request({
        url: "/businessservice/classLibraryItem/treeList",
        method:"get",
        params: query
    })
}

/*===================关联人文美育视频==================*/
export const  classLibraryRelationVideo =(data) =>{
    return request({
        url: "/businessservice/classLibraryVideo/relationVideo",
        method:"post",
        data: data
    })
}